// Availability states returned by getVariantAvailabilityState
// 1 → In Stock
// 2 → Coming Soon (backorders denied + coming soon)
// 3 → Sold Out (backorders denied)
// 4 → Preorder (backorders allowed + dispatch date)
// 5 → Backorder (backorders allowed + no dispatch date)

function getVariantAvailabilityState(variant) {
  if (!variant) return null;

  const dispatchDate = window.variantMetafields?.[variant.id]?.estimated_dispatch;
  const comingSoon = window.variantMetafields?.[variant.id]?.variant_coming_soon;

  const inStock = variant.inventory_quantity > 0;
  const continueSelling = variant.inventory_policy === "continue";
  const hasDispatchDate = Boolean(dispatchDate);

  // 1 — In Stock
  if (inStock) return 1;

  // Inventory <= 0 from this point on

  // 2 — Coming Soon (backorders denied + coming soon)
  if (!continueSelling && comingSoon == "true") return 2;

  // 3 — Sold Out (backorders denied)
  if (!continueSelling) return 3;

  // 4 — Preorder (backorder allowed + dispatch date present)
  if (dispatchDate) return 4;

  // 5 — Backorder (backorder allowed + no dispatch date)
  return 5;
}

/**
 * Injects a standard Christmas delivery message into the dedicated div.
 * @param {boolean} visible - Whether to show or hide the message.
 * @param {string} message - The custom message to display (optional).
 */
function updateChristmasMessage(visible, message = "🎄 Arrives before <strong>Christmas</strong>") {
  const christmasEl = document.querySelector("#christmasDeliveryMesg");

  if (!christmasEl) return;

  if (visible) {
    christmasEl.innerHTML = message;
    christmasEl.style.display = "block";
  } else {
    christmasEl.innerHTML = "";
    christmasEl.style.display = "none";
  }
}

// Main UI update
function updateProductUI(variant) {
  const container = document.querySelector('.leave_warehouse');
  const addButton = document.querySelector('button.addToCartBtn');
  const notifyBtn = document.querySelector('.notifyjs');

  if (!variant) return;

  const newPtag = container?.querySelector('.newptag') || null;
  const metafieldData = window.variantMetafields?.[variant.id]?.estimated_dispatch;
  const state = getVariantAvailabilityState(variant);

  // Utility helpers
  const setHTML = (el, html = "") => { if (el) el.innerHTML = html; };
  const setButton = (text, opts = {}) => {
    if (!addButton) return;
    const { disabled = false, preorder = false, oos = false } = opts;
    addButton.disabled = disabled;
    addButton.classList.toggle('disabled', disabled);
    addButton.classList.toggle('oos', oos);
    addButton.classList.toggle('preorder', preorder);
    const span = addButton.querySelector('span');
    if (span) span.textContent = text;
  };
  const setNotify = visible => {
    if (notifyBtn) notifyBtn.style.display = visible ? 'block' : 'none';
  };

  // Reset defaults
  setHTML(newPtag, "");
  setNotify(false);
  updateChristmasMessage(false); 

  // Container visibility: hidden for the coming soon and sold out states, flex otherwise
  if (container) {
    if (state === 2 || state === 3) {
      container.style.display = "none";
    } else {
      container.style.display = "flex";
    }
  }

  // Main logic
  switch (state) {
  // 1 — IN STOCK
    case 1:
      let deliveryMsg =
        "Estimated delivery: <span class='days dispatchmessage'><strong>with you in 48 hours</strong></span>";

      // Flag to track if the default 48h message is shown, overriding the Christmas message
      let is48HourDefault = true; 

      if (variant.tags?.includes("stock-is-limited")) {
        deliveryMsg = "BE QUICK! Stock is limited.";
        is48HourDefault = false;
      } else if (variant.tags?.includes("3-business-days")) {
        deliveryMsg =
          "Estimated delivery: <span class='days dispatchmessage'>3 business days</span>";
        is48HourDefault = false;
      } else if (window.productDispatchDefault) {
        deliveryMsg = `Estimated delivery: <span class='days dispatchmessage'>${window.productDispatchDefault}</span>`;
        is48HourDefault = false;
      }

      setHTML(newPtag, deliveryMsg);
      setButton("Add To Cart");

      // Show the message unless overridden by a custom tag
      if (is48HourDefault) updateChristmasMessage(true);
      break;

    // 2 — SOLD OUT + coming soon (deny backorders)
    case 2:
      setHTML(newPtag, "");
      setButton("Coming Soon!", { disabled: true, oos: false });
      setNotify(true);
      break;

    // 3 — SOLD OUT (deny backorders)
    case 3:
      setHTML(newPtag, "");
      setButton("WOW! THIS SOLD OUT QUICKLY", { disabled: true, oos: true });
      setNotify(true);
      break;

    // 4 — PREORDER (continue + dispatch date)
    case 4:
      setHTML(newPtag, `Estimated Dispatch: ${metafieldData}`);
      setButton("Pre Order", { preorder: true });
      break;

    // 5 — BACKORDER (continue + no dispatch date)
    case 5:
      setHTML(
        newPtag,
        "Estimated delivery: <span class='days dispatchmessage'><strong>with you in 48 hours</strong></span>"
      );
      setButton("Add To Cart");
      updateChristmasMessage(true);
      break;
  }
  syncStickyATC();
}

// Sync main ATC → sticky ATC (visual + text only)
function syncStickyATC() {
  const mainBtn = document.querySelector('.addToCartBtn');
  const stickyBtn = document.querySelector('.batc_btn');

  if (!mainBtn || !stickyBtn) return;

  // Text
  const mainSpan = mainBtn.querySelector('span');
  stickyBtn.textContent = mainSpan
    ? mainSpan.textContent.trim()
    : mainBtn.textContent.trim();

  // Visual state classes to mirror
  const mirrorClasses = ['oos', 'preorder', 'disabled'];

  mirrorClasses.forEach(cls => {
    stickyBtn.classList.toggle(cls, mainBtn.classList.contains(cls));
  });
}

// Sticky ATC always scrolls to main ATC
(function() {
  const initStickyScroll = () => {
    const stickyBtn = document.querySelector('.batc_btn');
    if (!stickyBtn) return;

    stickyBtn.addEventListener('click', function (e) {
      const mainATC = document.querySelector('.product-action .addToCartBtn');
      if (!mainATC) return;

      e.preventDefault();

      const targetPosition = mainATC.getBoundingClientRect().top + window.pageYOffset;
      const windowHeight = window.innerHeight;
      const targetHeight = mainATC.offsetHeight;

      const position = targetPosition - (windowHeight - targetHeight) / 2;

      window.scroll({
        top: position,
        behavior: 'smooth'
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyScroll);
  } else {
    initStickyScroll();
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  // Initial variant
  const initialVariant = window.productJson?.selected_or_first_available_variant;
  if (initialVariant) updateProductUI(initialVariant);

  // Watch for variant changes
  const variantSelectors = document.querySelectorAll('select[name="id"], input[name="id"]');
  variantSelectors.forEach(el => {
    el.addEventListener('change', e => {
      const variantId = parseInt(e.target.value, 10);
      const variant = window.productJson?.variants.find(v => v.id === variantId);
      if (variant) updateProductUI(variant);
    });
  });
});